var giphy_viewer_default = {
  "giphyWrapper": "MhYHK",
  "giphy_player": "OZU7w",
  "playIcon": "ifz3b",
  "gifRatio": "QjxG3"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
